/**
 * @ignore
 */
const g2=require('../../../g2');
const BufferDrawTool = require('./BufferDrawTool');

class DrawPointTool extends BufferDrawTool {
    constructor(opts) {
        super(opts);
        //
        this.defaultSymbol = new g2.sfs.SimpleMarkerSymbol();
    }
    onMouseUp(button, shift, screenx, screeny, mapx, mapy, handled) {
        const point = new g2.sfs.Point({
            x: mapx,
            y: mapy,
            spatialReference: this.options.map.spatialReference,
        });
        const element = new g2.sfs.Element({
            geometry: point,
            symbol: this.symbol,
        });
        if (this.params.layer) {
            this.params.layer.add(element);
        }
        this.params.callback.call(this.params.context, element);
    }
}
module.exports = DrawPointTool;